import City from './city.vue';
export default City;


// WEBPACK FOOTER //
// ./src/components/city/index.js